import { atom } from 'jotai';
import InkyAPI from '../API/InkyAPI';
import { HeroBanner } from '../Models/HeroBanner';

export const HeroCache = atom<HeroBanner | undefined>(null);

export const fetchHero = atom((get) => {
    return get(HeroCache);
}, (get, set) => {
    if (get(HeroCache)) {
        return;
    }
    InkyAPI.getHeroBanner().then((res) => {
        console.log('result from atom', res);
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        set(HeroCache, res.data);
    });
});
